import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponents, ModalContainerComponent } from './modal-container.component';
import { ModalService } from '../../services/modal/modal.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseFormModule } from '../form/base-form.module';
import { SharedModule } from '../shared/shared.module';
import { LoadingModule } from '../shared/loading/loading.module';
import { SpinnerModule } from '../shared/spinner/spinner.module';
import { SafeHtmlPipe } from '../../../../common/angular-shared/SafeHtmlPipe';
import { WidgetPaymentCustomerModule } from '../../../../common/widgets/payment-update-widget/js/customer/widget.payment.customer.module';
import { BeneModule } from '../../../../common/widgets/bene-widget/js/bene.module';
import { WidgetContactUpdaterModule } from '../../../../common/widgets/contact-update-widget/contact-update.module';
import { ApplicationService } from '../../services/application/application.service';
import { ToggleButtonModule } from '../../../components/toggle-button/toggle-button.module';
import { CpButtonModule } from '../../../components/cp-button/cp-button.module';
import { DesignSystemModule } from '@hit/coverpath-design-system';

@NgModule({
  declarations: [ModalContainerComponent, ...ModalComponents, SafeHtmlPipe],
  exports: [ModalContainerComponent],
  imports: [
    CommonModule,
    FormsModule,
    BaseFormModule,
    ReactiveFormsModule,
    SharedModule,
    LoadingModule,
    SpinnerModule,
    WidgetPaymentCustomerModule,
    BeneModule,
    WidgetContactUpdaterModule,
    ToggleButtonModule,
    CpButtonModule,
    DesignSystemModule,
  ],
  providers: [ModalService, ApplicationService],
})
export class ModalModule {}
